import { CHEMICAL_PRICE_MAX_FRACTIONS } from "../../chemicalLibrary/chemicalLibrary.constants";

import {
  DEFAULT_CHEMICAL_CURRENCY_CODE,
  DEFAULT_CHEMICAL_DENSITY_UNIT,
} from "../../../constants/chemicals.constants";
import { CURRENCY_SYMBOLS } from "../../../constants/currencies.constants";
import {
  ACID_KEY,
  ADDITIVE_ALKALI_KEY,
  ALKALI_KEY,
} from "../../../constants/global.constants";

import { convertUptoDigits } from "../../../utils/appUtils";

const colorPalette = {
  [ACID_KEY]: {
    light: "#AD87F7",
    pale: "#EFE7FD",
  },
  [ALKALI_KEY]: {
    light: "#FFCD00",
    pale: "#FFFBCC",
  },
  [ADDITIVE_ALKALI_KEY]: {
    light: "#96661D",
    pale: "#FFF3E9",
  },
};

const getChemicalCardStyles = (color) => ({
  border: `1px solid ${color.light}`,
  backgroundColor: color.pale,
});

const ChemicalCards = ({ chemicals }) => {
  return (
    <div className="wavepro-chemical-cards">
      {chemicals.map((chem, idx) => (
        <div
          key={`${chem.name}-${idx}`}
          className="wavepro-chemical-card"
          style={getChemicalCardStyles(colorPalette[chem.category])}
        >
          <div className="wavepro-chemical-row">
            <span>{chem.bulk_concentration}%</span>
            <span>
              {chem.bulk_density} {DEFAULT_CHEMICAL_DENSITY_UNIT}
            </span>
          </div>
          <div className="wavepro-chemical-row">
            <div className="wavepro-chemical-name">{chem.symbol}</div>
            <div className="wavepro-chemical-price">
              {CURRENCY_SYMBOLS[DEFAULT_CHEMICAL_CURRENCY_CODE]}{" "}
              {convertUptoDigits(chem.price, CHEMICAL_PRICE_MAX_FRACTIONS)}{" "}
              {chem.unit}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChemicalCards;
